import { z } from 'zod/v4'

export const FileTypeValidator = z.enum(['boundaries', 'metadata', 'newMovers'])
export type FileType = z.infer<typeof FileTypeValidator>

export const HoneyGridVersionFileValidator = z.object({
	fileName: z.string(),
	type: FileTypeValidator,
	status: z.enum(['pending', 'processing', 'completed', 'failed', 'stopped']),
	uploadedAt: z.string(),
	updatedAt: z.string(),
	startTime: z.number().optional(),
	completedTime: z.number().optional(),
	processingTime: z.number().optional(),
	chunksTotal: z.number().optional(),
	chunksProcessed: z.number().optional(),
	error: z.string().optional(),
	size: z.number(),
	name: z.string(),
	processorId: z.string().optional(),
})
export type HoneyGridVersionFile = z.infer<typeof HoneyGridVersionFileValidator>

export const HoneyGridVersionValidator = z.object({
	id: z.string(),
	createdAt: z.string(),
	updatedAt: z.string(),
	completedAt: z.string().optional(),
	status: z.enum(['pending', 'processing', 'completed', 'failed', 'stopped']),
	files: z.array(HoneyGridVersionFileValidator),
	workflows: z
		.object({
			orchestrator: z.string().optional(),
			gridBuilder: z.string().optional(),
		})
		.optional(),
	completedFiles: z
		.record(
			FileTypeValidator,
			z.array(
				z.object({
					fileName: z.string(),
					completedAt: z.string(),
				})
			)
		)
		.default({
			metadata: [],
			boundaries: [],
			newMovers: [],
		}),
})
export type HoneyGridVersion = z.infer<typeof HoneyGridVersionValidator>

export const CarrierRouteStateFilesValidator = z.record(
	FileTypeValidator,
	z.object({
		data: z.record(z.string(), z.unknown()),
		processedAt: z.string(),
	})
)

export const CarrierRouteStateValidator = z.object({
	routeId: z.string().optional(),
	files: CarrierRouteStateFilesValidator.optional(),
	status: z.enum(['pending', 'processing', 'completed', 'failed', 'stopped']).optional(),
	updatedAt: z.string().optional(),
})

export type CarrierRouteStateFiles = z.infer<typeof CarrierRouteStateFilesValidator>
export type CarrierRouteState = z.infer<typeof CarrierRouteStateValidator>
